<script lang="ts">
  /**
   * Ein Knopf, der nur aus einem Symbol besteht.
   *
   * `titel` ist Pflicht und nicht optional gemeint: Ein Knopf ohne Beschriftung
   * ist für Vorlesegeräte namenlos, und beim Zeigen weiß auch ein sehender
   * Nutzer nicht, was „⧉" tun wird. Daraus werden `title` und `aria-label`.
   *
   * Trefferfläche 28×28 im Web, 44×44 mit `gross` — das ist die Mindestgröße
   * fürs Telefon, und die schmale Fassung der Web-App wird auf dem Telefon
   * benutzt.
   */
  import Zeichen, { type ZeichenName } from './Zeichen.svelte';

  interface Props {
    name: ZeichenName;
    titel: string;
    gefahr?: boolean;
    deaktiviert?: boolean;
    gross?: boolean;
    groesse?: number;
    onclick?: () => void;
  }
  let {
    name,
    titel,
    gefahr = false,
    deaktiviert = false,
    gross = false,
    groesse = 18,
    onclick
  }: Props = $props();
</script>

<button
  type="button"
  class:gefahr
  class:gross
  title={titel}
  aria-label={titel}
  disabled={deaktiviert}
  {onclick}
>
  <Zeichen {name} {groesse} />
</button>

<style>
  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 0;
    border: 1px solid transparent;
    border-radius: var(--radius-mini);
    background: transparent;
    color: var(--text-dim);
    cursor: pointer;
    transition: color 140ms ease-out, background-color 140ms ease-out,
      border-color 140ms ease-out;
  }
  /* `--zeichenknopf-gross` ist der Griff, an dem eine umgebende Leiste das
     Maß nachstellen darf — ohne Griff geht das nicht: Eine Regel von außen
     (`.neben :global(button)`) hat weniger Gewicht als `button.gross` hier,
     und genau daran ist die 32-px-Fassung der Nebenhandlungen jahrelang
     lautlos gescheitert. Eine geerbte Eigenschaft kennt keinen
     Spezifitätsstreit. Ohne Setzung bleibt es beim vollen Fingermaß. */
  button.gross {
    width: var(--zeichenknopf-gross, var(--tippziel));
    height: var(--zeichenknopf-gross, var(--tippziel));
  }

  button:hover:not(:disabled) {
    color: var(--text);
    background: var(--surface-2);
    border-color: var(--border-stark);
  }
  button.gefahr:hover:not(:disabled) {
    color: var(--danger);
    background: var(--danger-weich);
    border-color: var(--danger);
  }
  button:disabled { opacity: 0.45; cursor: not-allowed; }
</style>
